import { render } from "./PaymentRadio.vue?vue&type=template&id=0c0f4966&scoped=true"
import script from "./PaymentRadio.vue?vue&type=script&lang=js"
export * from "./PaymentRadio.vue?vue&type=script&lang=js"

import "./PaymentRadio.vue?vue&type=style&index=0&id=0c0f4966&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c0f4966"]])

export default __exports__